export default __webpack_public_path__ + "static/media/login-background.d21ab0e4.jpeg";